import { render, staticRenderFns } from "./ArticleSearchForm.vue?vue&type=template&id=44413d8a"
import script from "./ArticleSearchForm.vue?vue&type=script&lang=ts"
export * from "./ArticleSearchForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports